import React, { useContext } from "react";
import paperTypeContext from "../../Global varaibles/PaperType_filter/PaperType_context";

function PaperFilter() {
  const context = useContext(paperTypeContext);
  const types = ["Journal", "Conference"];
  const { setPaperType } = context;

  return (
    <>
      <li>
        <button
          className="dropdown-item"
          onClick={() => {
            setPaperType("");
          }}
        >
          All
        </button>
      </li>

      {types.map((e, index) => (
        <li key={index}>
          <button
            className="dropdown-item"
            onClick={() => {
              setPaperType(e);
            }}
          >
            {e}
          </button>
        </li>
      ))}
    </>
  );
}

export default PaperFilter;
